export default {
    home_page_title: "معلومات الحساب",
    security_page_title: "نظام امآن",
    security_setting_page_title: "نظام امآن",
    security_phone_label: "الهاتف",
    security_email_label: "البريد الإلكتروني",
    security_question_label: "سؤال الآمان",
    security_unset_text: "لم يتم الإعداد",
    security_setted_text: "تم الإعداد",
    security_question_options: [
        "اسم والدتك ؟",
        "تاريخ ميلاد زوجتك؟",
        "اسم والدك ؟",
        "رقم الطالب أو رقم العمل ؟",
        "اسم صديق مقرب لك في مرحلة الطفولة؟",
        "اسم شخص تعرفه له نفوذ كبير؟"
    ],
    password_lost_page_title: "نسيت كلمة المرور",
    password_reset_page_title: "إعادة ضبط كلمة المرور",
    password_lost_account_placeholder:
        "إدخال الحساب الذي نسيت كلمة المرور الخاصة به",
    empty_lost_account_tips: "لا يمكن أن يكون اسم المستخدم فارغ",
    iscorrect_lost_account_tips: "المستخدم غير موجود",
    password_reset_new_placeholder: "كلمة السر الجديدة",
    password_reset_confirm_placeholder: "تأكيد كلمة السر الجديدة",
    password_verify_page_title: "التحقق من الهوية",
    phone_verify_page_title: "التحقق من الهوية",
    email_verify_page_title: "التحقق من الهوية",
    question_verify_page_title: "التحقق من الهوية",
    phone_reset_page_title: "الهاتف",
    email_reset_page_title: "البريد الإلكتروني",
    question_reset_page_title: "سؤال الآمان",
    phone_binding_text: "رقم هاتفك الذي تم الإرتباط به",
    email_binding_text: "البريد الخاص بك والذي تم الإرتباط به",
    verification_code_text: "رمز التحقق",
    resend_text: "الإسال مرة اخرى",
    empty_phone_number_tips: "يرجى إدخال رقم الهاتف",
    iscorrect_phone_number_tips: "يرجى إدخال صيغة صحيحة لرقم الهاتف",
    empty_verification_code_tips: "الرجاء إدخال رمز التحقق",
    iscorrect_verification_code_tips: "خطأ في رمز التحقق",
    password_placeholder: "كلمة السر",
    empty_password_tips: "من فضلك أدخل كلمة المرور",
    iscorrect_password_tips: "خطأ في كلمة المرور",
    mismatched_rule_password_tips:
        "لا يمكن أن تحتوي كلمة المرور على & ، # ، مسافة",
    different_confirm_password_tips: "كلمتي المرور غير متطابقتان",
    empty_email_tips: "فضلاً قم بإدخال البريد",
    iscorrect_email_tips: "البريد غير صحيح",
    answer_placeholder: "إجابة",
    empty_question_tips: "إختيار سؤال الآمان",
    empty_answer_tips: "إدخال الإجابة,",
    iscorrect_answer_tips: "خطأ في الإجابة",
    next_step_text: "الخطوة التالية",
    submit_text: "تسليم",
    submit_success_tips: "نجاح الإعداد",
    submit_error_tips: "العملية فشلت، يرجى المحاولة مرة أخرى",
    get_data_fail_tips: "هناك مشاكل في الاتصال، فضلا قم بالمحاولة لاحقاً",
    use_other_verification_type_text: "التحقق بالطرق الأخرى",
    custom_support_notice:
        "لم يتم تعين حساب الامان ،يمكنك ومن خلال جهاز الكمبيوتر الدخول الى الرابط التالي والقيام   بخطوات التأمين" +
        process.env.VUE_APP_ORIGIN_PROFILE
};
